module.exports = __webpack_public_path__ + "img/event_share_stories.9039e0b4.png";